import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  configureEmailResourcePool(vcId, rpId, emailObj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/resourcePool/' + rpId + '/emailIds';
    return this.http
      .post(url, JSON.stringify(emailObj))
      .map(
        res => this.value
      );
  }

  getEmailResourcePool(vcId, rpId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/resourcePool/' + rpId + '/emailIds';
    return this.http
      .get(url)
      .map(
        (res:any) => this.value = res
      );
  }

  configureEmailVirtualMachine(vcId, vmId, emailObj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/emailIds';
    return this.http
      .post(url, JSON.stringify(emailObj))
      .map(
        res => this.value
      );
  }

  getEmailVirtualMachine(vcId, vmId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/emailIds';
    return this.http
      .get(url)
      .map(
        (res:any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/configure-email/configure-email.service.ts